// extracted by mini-css-extract-plugin
export default {"resource":"KResourceItem-module__resource--Yi+kl"};